import { getCurrentStorageName, getObjectFromSession, setObjectToSession } from '@/utils/session-utils';

import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_CENTRO_CUSTO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_FORNECEDOR,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_GRUPO,
  SET_LOCAL_ENTREGA,
  SET_SITUACAO,
  SET_LIST_OPTIONS,
  SET_CURRENT_PAGE,
  SET_FILTER,
  SET_OFFSET,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
  SET_VIEW_OPTION,
} from './mutations.type';

import { PREFIX_SESSION_STATE_NAME } from './constants';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_LOCAL_ENTREGA](state, localEntrega) {
    state.localEntrega = localEntrega;
  },
  [SET_CENTRO_CUSTO](state, centroCusto) {
    state.centroCusto = centroCusto;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_RESPONSAVEL](state, responsavel) {
    state.responsavel = responsavel;
  },
  [SET_FORNECEDOR](state, fornecedor) {
    state.fornecedor = fornecedor;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
  [SET_SITUACAO](state, situacao) {
    state.situacao = situacao;
  },
  [SET_CURRENT_PAGE](state, page) {
    state.listOptions.page = page;
  },
  [SET_FILTER](state, filter) {
    state.listOptions.filter = filter;
  },
  [SET_OFFSET](state, offset) {
    state.listOptions.offset = offset;
  },
  [SET_LIST_OPTIONS](state, listOptions) {
    state.listOptions = listOptions;
  },
  [SET_VIEW_OPTION](state, viewOption) {
    state.viewOption = viewOption;
  },
  /* eslint-disable max-len */
  [SET_CURRENT_SESSION_STATE](state, ids) {
    const stateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );

    if (stateName) {
      setObjectToSession(stateName, state);
    }
  },
  [INIT_STATE](state, ids) {
    const currentStateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    const sessionObjectState = getObjectFromSession(currentStateName);

    state.selectedStatus = sessionObjectState?.selectedStatus || state.selectedStatus;
    state.searchText = sessionObjectState?.searchText || state.searchText;
    state.empresa = sessionObjectState?.empresa || state.empresa;
    state.localEntrega = sessionObjectState?.localEntrega || state.localEntrega;
    state.centroCusto = sessionObjectState?.centroCusto || state.centroCusto;
    state.produto = sessionObjectState?.produto || state.produto;
    state.projeto = sessionObjectState?.projeto || state.projeto;
    state.responsavel = sessionObjectState?.responsavel || state.responsavel;
    state.fornecedor = sessionObjectState?.fornecedor || state.fornecedor;
    state.dataFinal = sessionObjectState?.dataFinal || state.dataFinal;
    state.dataInicial = sessionObjectState?.dataInticial || state.dataInticial;
    state.grupo = sessionObjectState?.grupo || state.grupo;
    state.situacao = sessionObjectState?.situacao || state.situacao;
    state.listOptions = sessionObjectState?.listOptions || state.listOptions;
    state.viewOption = sessionObjectState?.viewOption || state.viewOption;
  },
};
